import { render, staticRenderFns } from "./BrandsDropdown.vue?vue&type=template&id=6d7dd4dc&"
import script from "./BrandsDropdown.vue?vue&type=script&lang=js&"
export * from "./BrandsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BrandsDropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports